const designWidth = 375 //设计稿宽度
var deviceWidth = window.deviceWidth = document.documentElement.clientWidth; //当前设备宽度
var deviceHeight = document.documentElement.clientHeight;//当前设备高度
document.documentElement.style.fontSize = (deviceWidth / designWidth) + 'px';
window.baseline = (deviceWidth / designWidth)
window.device = deviceWidth<450?'phone':deviceWidth<768?'pad':'pc'
document.documentElement.setAttribute("data-device",window.device)

if (deviceWidth >= 768 && deviceWidth<=1080) {
  // document.documentElement.style.fontSize = "1px";
  document.documentElement.style.fontSize = 1.2 + 'px';
  window.bigScreen = true
  window.baseline = 1.2
} else if (deviceWidth >= 1080){
  document.documentElement.style.fontSize = "1px";
  window.bigScreen = false
  window.baseline = 1
}
var baseline = window.baseline = deviceWidth / designWidth;

window.onresize = function () {
  
  deviceWidth = window.deviceWidth = document.documentElement.clientWidth; //当前设备宽度
  deviceHeight = document.documentElement.clientHeight;//当前设备高度
  document.documentElement.style.fontSize = (deviceWidth / designWidth) + 'px';
  window.baseline = (deviceWidth / designWidth)
  window.device = deviceWidth<450?'phone':deviceWidth<768?'pad':'pc'
  document.documentElement.setAttribute("data-device",window.device)
  
  if (deviceWidth >= 768 && deviceWidth <= 1080) {
    document.documentElement.style.fontSize = 1.2 + 'px';
    window.bigScreen = true
    window.baseline = 1.2
  } else if (deviceWidth >= 1080){
    document.documentElement.style.fontSize = "1px";
    window.bigScreen = false
    window.baseline = 1
  }
}